export default __webpack_public_path__ + "static/media/purple_getthrough.6129e897.webp";